export default {
  nav: {
    platform: 'Platform',
    aiAgents: 'AI Agents',
    features: 'Features',
    developers: 'Developers',
    roadmap: 'Roadmap',
    launchApp: 'Launch App',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
  },
  hero: {
    badge: 'LIVE MAINNET',
    title1: 'The AI-Native',
    title2: 'Trading Infrastructure',
    subtitle:
      'Fully on-chain perpetuals, AI execution agents, prediction markets, and real-time liquidity \u2014 all in one unified platform.',
    startTrading: 'Start Trading',
    launchAgent: 'Launch Agent',
    apiDocs: 'API Docs',
    volume24h: '24H Volume',
    activeTraders: 'Active Traders',
    uptime: 'Uptime',
    terminalName: 'zhisu-terminal',
    live: 'LIVE',
    oi: 'OI',
    funding: 'Funding',
    spread: 'Spread',
    aiActive: 'AI Active',
    liveTrades: 'Live Trades',
    realtime: 'Real-time',
    long: 'LONG',
    short: 'SHORT',
  },
  metrics: {
    realtimeMetrics: 'Real-time Metrics',
    platformGlance: 'Platform at a Glance',
    volume24h: '24H Volume',
    openInterest: 'Open Interest',
    activeTraders: 'Active Traders',
    aiExecutions: 'AI Executions',
    fundingRate: 'Funding Rate',
    totalTrades: 'Total Trades',
  },
  agents: {
    autonomousIntelligence: 'Autonomous Intelligence',
    aiTradingAgents: 'AI Trading Agents',
    description:
      'Deploy autonomous AI agents that trade 24/7 with machine-learned strategies. Each agent is fully transparent, auditable, and battle-tested.',
    pnl30d: 'PNL (30d)',
    winRate: 'Win Rate',
    trades24h: 'Trades (24h)',
    avgHold: 'Avg Hold',
    risk: 'Risk',
    exploreAll: 'Explore All Agents',
  },
  features: {
    productSuite: 'Product Suite',
    everythingNeed: 'Everything You Need to Trade',
    description:
      'A complete trading infrastructure from perpetuals to AI execution, all on-chain and fully transparent.',
    learnMore: 'Learn more',
  },
  dev: {
    developerFirst: 'Developer First',
    builtForBuilders: 'Built for Builders',
    description:
      'Complete API access, SDKs, and real-time WebSocket feeds. Build trading bots, agents, and custom strategies in minutes.',
    sdksAndApis: 'SDKs & APIs',
    restApi: 'REST API',
    websocket: 'WebSocket',
    pythonSdk: 'Python SDK',
    agentSdk: 'Agent SDK',
    tradingSdk: 'Trading SDK',
    viewDocs: 'View Full Documentation',
  },
  arch: {
    systemDesign: 'System Design',
    dualEngine: 'Dual Engine Architecture',
    description:
      'Four specialized engines working in harmony to deliver sub-100ms execution with institutional-grade reliability.',
    aiEngine: 'AI Engine',
    liquidityEngine: 'Liquidity Engine',
    executionEngine: 'Execution Engine',
    riskEngine: 'Risk Engine',
    latency: 'Latency',
    models: 'Models',
    depth: 'Depth',
    pairs: 'Pairs',
    tps: 'TPS',
    uptime: 'Uptime',
    coverage: 'Coverage',
    alerts: 'Alerts',
  },
  roadmap: {
    ourJourney: 'Our Journey',
    roadmap2026: 'Roadmap 2026',
    description:
      'Building the future of AI-native trading infrastructure, one quarter at a time.',
    completed: 'Completed',
    inProgress: 'In Progress',
    upcoming: 'Upcoming',
  },
  footer: {
    product: 'Product',
    developers: 'Developers',
    company: 'Company',
    legal: 'Legal',
    description:
      'The AI-native trading infrastructure for on-chain perpetuals, prediction markets, and autonomous execution.',
    allRights: 'All rights reserved.',
    systemsOperational: 'All systems operational',
  },
  content: {
    agents: {
      scalper: {
        name: 'AI Scalper',
        description:
          'High-frequency momentum trading with sub-second execution on volatility spikes',
      },
      'funding-arb': {
        name: 'Funding Arb Bot',
        description:
          'Automated funding rate arbitrage across perpetual exchanges',
      },
      'meme-hunter': {
        name: 'Meme Hunter',
        description:
          'Social sentiment analysis and early entry on viral token movements',
      },
      'prediction-ai': {
        name: 'Prediction AI',
        description:
          'Machine learning models forecasting market direction with 71% accuracy',
      },
      'whale-tracker': {
        name: 'Whale Tracker',
        description:
          'On-chain analysis tracking smart money movements and whale wallets',
      },
    },
    features: {
      perpetual: {
        title: 'Perpetual Trading',
        description:
          'Fully on-chain perpetual futures with up to 50x leverage and zero slippage',
      },
      'ai-execution': {
        title: 'AI Execution',
        description:
          'AI-powered order routing and optimal entry timing across all markets',
      },
      prediction: {
        title: 'Prediction Markets',
        description:
          'Decentralized prediction markets on crypto outcomes with instant settlement',
      },
      'copy-trading': {
        title: 'Copy Trading',
        description:
          'Follow top-performing AI agents and verified traders with one click',
      },
      hyperevm: {
        title: 'HyperEVM',
        description:
          'Multi-chain expansion across Ethereum, Solana, Arbitrum, and Base',
      },
      vault: {
        title: 'Strategy Vault',
        description:
          'Automated yield-generating strategies with built-in risk management',
      },
    },
    engines: {
      'ai-engine': {
        name: 'AI Engine',
        description:
          'Neural networks for signal generation, pattern recognition, and predictive modeling',
      },
      'liquidity-engine': {
        name: 'Liquidity Engine',
        description:
          'Deep orderbook aggregation and cross-chain liquidity routing',
      },
      'execution-engine': {
        name: 'Execution Engine',
        description:
          'Sub-100ms order execution with MEV protection and optimal routing',
      },
      'risk-engine': {
        name: 'Risk Engine',
        description:
          'Real-time position monitoring, liquidation protection, and portfolio hedging',
      },
    },
    roadmap: {
      q1: {
        title: 'Beta Launch',
        items: [
          'AI Agents v1 with 5 strategies',
          'Perpetual Trading Mainnet',
          'WebSocket Real-time API',
          'Cross-chain Bridge Integration',
        ],
      },
      q2: {
        title: 'Mainnet Expansion',
        items: [
          'Prediction Markets Launch',
          'Python & TypeScript SDKs',
          'Mobile Trading App Beta',
          'Institutional API Access',
        ],
      },
      q3: {
        title: 'Ecosystem Growth',
        items: [
          'Strategy Vaults Launch',
          'Copy Trading Platform',
          'HyperEVM Multi-chain',
          'Governance Framework',
        ],
      },
      q4: {
        title: 'Full Decentralization',
        items: [
          'ZhiSu Token Launch',
          'DAO Governance',
          'Layer 2 Scaling',
          'AI Model Marketplace',
        ],
      },
    },
    riskLevels: {
      high: 'High',
      low: 'Low',
      veryHigh: 'Very High',
      medium: 'Medium',
    },
    footerLinks: {
      product: ['Markets', 'AI Agents', 'Vaults', 'Leaderboard', 'Fees'],
      developers: ['API Reference', 'SDKs'],
      company: ['About', 'Careers', 'Press & Media', 'Brand Guidelines', 'Contact'],
      legal: ['Terms of Service', 'Privacy Policy', 'Cookie Policy', 'AML Policy', 'Risk Disclosure', 'User Agreement'],
    },
    timeAgo: '{{time}}s ago',
  },
};